"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaServerFooter = exports.SpaClientFooter = exports.SpaFooter = exports.SPA_FOOTER = void 0;
const react_1 = __importStar(require("react"));
const spa_footer_context_1 = require("./spa-footer.context");
const spa_util_1 = require("../../../../../common/spa/spa.util");
exports.SPA_FOOTER = 'spa-footer';
/**
 * SpaFooter for client side only apps.
 *
 * @returns React.FC.
 */
const SpaFooter = (footerProps) => {
    const footerContext = (0, react_1.useContext)(spa_footer_context_1.SpaClientOnlyFooterContext);
    (0, react_1.useEffect)(() => {
        if ((0, spa_util_1.isSuccessfulResponse)(footerProps, true)) {
            const footerScript = document.createElement('script');
            footerScript.setAttribute('data-testid', `${exports.SPA_FOOTER}-js`);
            footerScript.id = `${exports.SPA_FOOTER}-js`;
            footerScript.src = JSON.parse(footerProps.js).content;
            footerScript.async = true;
            footerScript.defer = true;
            document.body.appendChild(footerScript);
        }
    }, []);
    if (!(0, spa_util_1.isSuccessfulResponse)(footerProps, true)) {
        // An error occurred when getting props. Do not render Footer.
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "chewy-footer-conf", "data-page-type": footerContext.pageType, "data-mount-el-id": footerContext.mountElemId, "data-user-context": footerContext.userContext }),
        react_1.default.createElement("link", { rel: "stylesheet", "data-testid": `${exports.SPA_FOOTER}-css`, id: `${exports.SPA_FOOTER}-css`, href: (0, spa_util_1.getSpaResourceContent)(footerProps.css) })));
};
exports.SpaFooter = SpaFooter;
/**
 * SpaClientFooter for client side of ssr apps.
 *
 * @returns React.FC.
 */
const SpaClientFooter = () => {
    const footerContext = react_1.default.useContext(spa_footer_context_1.SpaFooterContext);
    const [showFallback, setShowFallback] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const cssScript = document.getElementById(`${exports.SPA_FOOTER}-css`);
        const htmlscript = document.getElementById(`${exports.SPA_FOOTER}-html`);
        if (!cssScript || !htmlscript || (0, spa_util_1.getQueryParam)('showWrapperFallback') === 'true') {
            // Show fallback content if css or html is undefined or parameter is set.
            setShowFallback(true);
        }
    }, []);
    if (showFallback) {
        return null;
    }
    const internalComponentType = (0, spa_util_1.getInternalComponentType)('footer', footerContext.pageType);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "chewy-footer-conf", "data-page-type": footerContext.pageType, "data-mount-el-id": footerContext.mountElemId, "data-user-context": footerContext.userContext }),
        react_1.default.createElement("style", { id: `${exports.SPA_FOOTER}-css`, "data-testid": `${exports.SPA_FOOTER}-css`, dangerouslySetInnerHTML: { __html: '' } }),
        react_1.default.createElement("div", { id: `${exports.SPA_FOOTER}-html`, "data-testid": `${exports.SPA_FOOTER}-html`, dangerouslySetInnerHTML: { __html: '' } }),
        react_1.default.createElement("script", { id: `${exports.SPA_FOOTER}-js`, "data-testid": `${exports.SPA_FOOTER}-js`, src: `${footerContext.baseURL}/${internalComponentType}.js`, defer: true })));
};
exports.SpaClientFooter = SpaClientFooter;
/**
 * SpaServerFooter for server side of ssr apps.
 *
 * @returns React.FC.
 */
const SpaServerFooter = (footerProps) => {
    const footerContext = react_1.default.useContext(spa_footer_context_1.SpaFooterContext);
    if (!(0, spa_util_1.isSuccessfulResponse)(footerProps)) {
        // An error occurred when getting props. Do not render Footer.
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "chewy-footer-conf", "data-page-type": footerContext.pageType, "data-mount-el-id": footerContext.mountElemId, "data-user-context": footerContext.userContext }),
        react_1.default.createElement("style", { id: `${exports.SPA_FOOTER}-css`, "data-testid": `${exports.SPA_FOOTER}-css`, dangerouslySetInnerHTML: { __html: (0, spa_util_1.getSpaResourceContent)(footerProps.css) } }),
        react_1.default.createElement("div", { id: `${exports.SPA_FOOTER}-html`, "data-testid": `${exports.SPA_FOOTER}-html`, dangerouslySetInnerHTML: { __html: (0, spa_util_1.getSpaResourceContent)(footerProps.html, true) } }),
        react_1.default.createElement("script", { id: `${exports.SPA_FOOTER}-js`, "data-testid": `${exports.SPA_FOOTER}-js`, src: (0, spa_util_1.getSpaResourceContent)(footerProps.js), async: true, defer: true })));
};
exports.SpaServerFooter = SpaServerFooter;
//# sourceMappingURL=spa-footer.js.map